export default () => ({
  commitsPath: null,
  projectId: null,
  commitsAuthors: [],
});
